import { createAction, createReducer } from "@reduxjs/toolkit";

// Types
import { PaginationParams, ParamsList } from "../../../../../types";

// State
import { AppState } from "../../../../store";

// Helpers
import { DefaultPaginationLimit } from "../../../../../consts";

interface ViewsAdminAuditTableState {
  params: Required<ParamsList>;
}

export const setParamsPagination = createAction<PaginationParams>(
  "views/admin/audit/table/params/pagination/set"
);

export const setParamsPaginationToken = createAction<string>(
  "views/admin/audit/table/params/pagination/token/set"
);

export const setParamsPaginationLimit = createAction<number>(
  "views/admin/audit/table/params/pagination/limit/set"
);

export const setParamsFilter = createAction<string>(
  "views/admin/audit/table/params/filter/set"
);

export const viewsAdminAuditTableInitialState: ViewsAdminAuditTableState = {
  params: {
    token: undefined,
    limit: DefaultPaginationLimit,
    filter: "",
  },
};

export const viewsAdminAuditTableReducer = createReducer(
  viewsAdminAuditTableInitialState,
  (builder) => {
    builder
      .addCase(setParamsPagination, (state, { payload: { limit, token } }) => {
        state.params.limit = limit;
        state.params.token = token;
      })
      .addCase(setParamsPaginationToken, (state, { payload }) => {
        state.params.token = payload;
      })
      .addCase(setParamsPaginationLimit, (state, { payload }) => {
        state.params.token = undefined;
        state.params.limit = payload;
      })
      .addCase(setParamsFilter, (state, { payload }) => {
        state.params.filter = payload;
      });
  }
);

export const selectTableParams = (state: AppState): Required<ParamsList> =>
  state.views.admin.audit.table.params;
